var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            "wrapper-closable": false,
            visible: _vm.rangeInfoDialogVisible,
            title: _vm.codeTitle,
            direction: "ltr",
            size: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rangeInfoDialogVisible = $event
            },
            close: _vm.clearForm,
          },
        },
        [
          _c(
            "div",
            { staticStyle: { margin: "0 10px 10px 10px" } },
            [
              !_vm.isModify
                ? _c(
                    "el-form",
                    {
                      staticClass: "searchCodeClass",
                      attrs: { model: _vm.searchForm, "label-position": "top" },
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: {
                            "flex-wrap": "wrap",
                            "align-items": "end",
                          },
                          attrs: { type: "flex", justify: "left" },
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.Zip"),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "95%" },
                                    attrs: {
                                      size: "small",
                                      clearable: "",
                                      placeholder: _vm.$t(
                                        "collectionCenter.pleaseInput"
                                      ),
                                    },
                                    on: { input: _vm.zipCodeValueChange },
                                    model: {
                                      value: _vm.searchForm.params.zipCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchForm.params,
                                          "zipCode",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "searchForm.params.zipCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.state"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        clearable: "",
                                        filterable: "",
                                        multiple: "",
                                        "collapse-tags": "",
                                        size: "small",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.getAddressCity(
                                            _vm.searchForm.params.states,
                                            1
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.searchForm.params.states,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchForm.params,
                                            "states",
                                            $$v
                                          )
                                        },
                                        expression: "searchForm.params.states",
                                      },
                                    },
                                    _vm._l(_vm.StateList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.label,
                                          value: item.label,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.city"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        clearable: "",
                                        filterable: "",
                                        multiple: "",
                                        size: "small",
                                        remote: "",
                                        "reserve-keyword": "",
                                        "remote-method": function (val) {
                                          return _vm.getCity(val, 1)
                                        },
                                      },
                                      on: {
                                        clear: function ($event) {
                                          return _vm.getAddressCity(
                                            _vm.searchForm.params.states,
                                            1
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.searchForm.params.cities,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchForm.params,
                                            "cities",
                                            $$v
                                          )
                                        },
                                        expression: "searchForm.params.cities",
                                      },
                                    },
                                    _vm._l(_vm.cityList, function (item, idx) {
                                      return _c("el-option", {
                                        key: idx,
                                        attrs: {
                                          label: item.name,
                                          value: item.name,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: { click: _vm.searchCode },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("collectionCenter.search")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-bottom": "6px" },
                                  attrs: { size: "small" },
                                  on: { click: _vm.resetCode },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("collectionCenter.reset")) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isModify
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "margin-bottom": "15px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.openAddForm },
                        },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.append")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "danger" },
                          on: { click: _vm.deleteAll },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.DeleteAll")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    "header-cell-style": {
                      background: "#f2f2f2",
                      color: "black",
                    },
                    border: "",
                    "max-height": "500px",
                    fit: true,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.ind"),
                      width: "80",
                      type: "index",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  (_vm.searchForm.pageNumber - 1) *
                                    _vm.searchForm.pageSize +
                                    scope.$index +
                                    1
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.state"),
                      prop: "zipCodeState",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.city"),
                      prop: "zipCodeCity",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.startZipCode"),
                      prop: "startZip",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.endZipCode"),
                      prop: "endZip",
                      align: "center",
                    },
                  }),
                  _vm.isModify
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("collectionCenter.operation"),
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#1d90ff",
                                        "font-size": "14px",
                                        cursor: "pointer",
                                        "margin-right": "5px",
                                        display: "inline-block",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editRow(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("collectionCenter.edit")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-popconfirm",
                                    {
                                      attrs: {
                                        title: _vm.$t(
                                          "collectionCenter.deleteSure"
                                        ),
                                      },
                                      on: {
                                        confirm: function ($event) {
                                          return _vm.delRow(scope.$index)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#1d90ff",
                                            "font-size": "14px",
                                            cursor: "pointer",
                                          },
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "collectionCenter.Delete"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          316881235
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
              !_vm.isModify
                ? _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c("el-pagination", {
                        staticStyle: { margin: "10px 0" },
                        attrs: {
                          layout: "total, sizes, prev, pager, next, jumper",
                          "current-page": _vm.searchForm.pageNumber,
                          "page-sizes": [10, 20, 50, 100, 500, 1000],
                          "page-size": _vm.searchForm.pageSize,
                          total: _vm.total,
                          background: "",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            return _vm.$set(
                              _vm.searchForm,
                              "pageNumber",
                              $event
                            )
                          },
                          "update:current-page": function ($event) {
                            return _vm.$set(
                              _vm.searchForm,
                              "pageNumber",
                              $event
                            )
                          },
                          "update:pageSize": function ($event) {
                            return _vm.$set(_vm.searchForm, "pageSize", $event)
                          },
                          "update:page-size": function ($event) {
                            return _vm.$set(_vm.searchForm, "pageSize", $event)
                          },
                          "current-change": _vm.getPage,
                          "size-change": _vm.searchCode,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isModify
                ? _c(
                    "div",
                    {
                      staticStyle: { "text-align": "right", margin: "15px 0" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.clearForm },
                        },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Close")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.saveForm },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "show-close": true,
            visible: _vm.addCodeVisible,
            title: _vm.addEditTitle,
            top: "10vh",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addCodeVisible = $event
            },
            close: _vm.closeAdd,
          },
        },
        [
          _c("div", { staticClass: "tip01" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("collectionCenter.tips")) +
                "：" +
                _vm._s(
                  _vm.$t("collectionCenter.startPostcodeCannotExceedEnd")
                ) +
                " "
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "rangeInfoFormRef",
              attrs: { model: _vm.rangeInfoForm, "label-position": "top" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            rules: {
                              required: true,
                              message: _vm.$t("GlobalSetObj.pleaseChoose"),
                              trigger: ["blur", "change"],
                            },
                            label: _vm.$t("collectionCenter.state"),
                            prop: "state",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                size: "small",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.getAddressCity(
                                    _vm.rangeInfoForm.state,
                                    2
                                  )
                                },
                              },
                              model: {
                                value: _vm.rangeInfoForm.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.rangeInfoForm, "state", $$v)
                                },
                                expression: "rangeInfoForm.state",
                              },
                            },
                            _vm._l(_vm.StateList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.label, value: item.label },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            rules: {
                              required: true,
                              message: _vm.$t("GlobalSetObj.pleaseChoose"),
                              trigger: ["blur", "change"],
                            },
                            label: _vm.$t("collectionCenter.city"),
                            prop: "city",
                          },
                        },
                        [
                          _c("ElSelectV2", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.cityList2,
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              filterable: "",
                              size: "small",
                              clearable: "",
                            },
                            on: {
                              clear: function ($event) {
                                return _vm.getAddressCity(
                                  _vm.rangeInfoForm.state,
                                  2
                                )
                              },
                            },
                            model: {
                              value: _vm.rangeInfoForm.city,
                              callback: function ($$v) {
                                _vm.$set(_vm.rangeInfoForm, "city", $$v)
                              },
                              expression: "rangeInfoForm.city",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            rules: {
                              required: true,
                              message: _vm.$t("placeOrder.pleaseInput"),
                              trigger: ["blur", "change"],
                            },
                            label: _vm.$t("collectionCenter.addPostcode"),
                            prop: "zipCodeRange",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: _vm.$t(
                                "collectionCenter.postcodeFormatInstructions"
                              ),
                              rows: "5",
                              type: "textarea",
                            },
                            on: {
                              input: _vm.handleZipCodeValueChange,
                              blur: _vm.zipCodeFil,
                            },
                            model: {
                              value: _vm.rangeInfoForm.zipCodeRange,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rangeInfoForm,
                                  "zipCodeRange",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "rangeInfoForm.zipCodeRange",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.errorData && _vm.errorData.length > 0
            ? _c(
                "div",
                { staticStyle: { color: "red" } },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.importFailedPostcodes"))
                    ),
                  ]),
                  _c("br"),
                  _vm._l(_vm.errorData, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticStyle: {
                          "margin-bottom": "5px",
                          "font-size": "14px",
                          "line-height": "16px",
                        },
                      },
                      [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(index + 1) + "."),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(item.errorRange) +
                            "，" +
                            _vm._s(item.errorMessage) +
                            " "
                        ),
                        item.canRemove
                          ? _c(
                              "span",
                              [
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: {
                                      title: _vm.$t(
                                        "collectionCenter.removeSure"
                                      ),
                                      "confirm-button-text": _vm.$t(
                                        "collectionCenter.yesRm"
                                      ),
                                      "cancel-button-text": _vm.$t(
                                        "collectionCenter.noRm"
                                      ),
                                    },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.remove(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "text-decoration": "underline",
                                          color: "#59a8fd",
                                          cursor: "pointer",
                                        },
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "collectionCenter.removeFromBranch"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeAdd } }, [
                _vm._v(_vm._s(_vm.$t("GlobalSetObj.Close"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addCode } },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }